import { get } from 'lodash'

import { Task, TaskLifecycleStates, getTranslatedString } from '@skinsoft/types'

export const author = (task: Task) => get(task, 'managementData.creatorUser');

export const incrementalTitle = (task: Task) => get(task, 'taskSchema.idIdentification');

export const endDate = (task: Task) => {
    const serializedDate = get(task, 'taskSchema.limitDate.skinIntervalComplexes[0].startInterval.date', null) || null;
    return serializedDate ? new Date(serializedDate) : undefined;
};

export const startDate = (task: Task) => {
    const serializedDate = get(task, 'taskSchema.demandDate.skinIntervalComplexes[0].startInterval.date', null) || null;
    return serializedDate ? new Date(serializedDate) : undefined;
};

export const title = (task: Task) => get(task, 'translatedTitle') || get(task, 'title');

export const operatorComment = (task: Task, locale) =>
    getTranslatedString(get(task, 'taskSchema.operatorComment', null), locale) || null;

export const precisionRequest = (task: Task) =>
    get(task, 'taskSchema.precisionRequest', null) || null;

export const linkableItems = (task: Task): Task['workflowSchema']['linkableItems'] =>
    get(task, 'workflowSchema.linkableItems', []) || []

export const associatedTasks = (task: Task) => get(task, 'taskSchema.associatedTasks', []) || [];

export const state = (task: Task): TaskLifecycleStates =>
    get(task, 'workflowSchema.currentState.name', null);
